import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import router from "@/router/index";
import { message } from "ant-design-vue";
import config from "@/api/config";
import ResultCodeType from "@/constant/ResultCodeType";

const baseUrl = config.baseUrl.BASE_URL_PHP;

const baseURLJAVA = config.baseUrl.BASE_JAVA_URL;

const baseURLJAVA2 = config.baseUrl.BASE_JAVA_WORK_URL;
//php
const instance = axios.create({
  baseURL: baseUrl,
  timeout: 60000,
});
instance.defaults.headers["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

//java
const instanceJava = axios.create({
  baseURL: baseURLJAVA,
  timeout: 60000,
});

//java2
const instanceJava2 = axios.create({
  baseURL: baseURLJAVA2,
  timeout: 60000,
});
instanceJava.defaults.headers["Content-Type"] =
  "application/json;charset=UTF-8";
// php响应拦截器
instance.interceptors.response.use(
  function (response) {
    if (response?.data?.code == ResultCodeType.token_expired) {
      message.warning("token失效，请重新登录。");
      router.push({
        path: "/",
      });
    }
    return response;
  },
  function (error) {
    message.error("网络异常");
    return Promise.reject(error);
  }
);
//java响应拦截器
instanceJava.interceptors.response.use(
  function (response) {
    if (response?.data?.code == ResultCodeType.token_expired) {
      message.warning("token失效，请重新登录。");
      router.push({
        path: "/",
      });
    }
    return response;
  },
  function (error) {
    // 将本次请求的错误对象继续向后抛出，让接收响应的处理函数进行操作
    return Promise.reject(error);
  }
);

//java2响应拦截器
instanceJava2.interceptors.response.use(
  function (response) {
    if (response?.data?.code == ResultCodeType.token_expired) {
      message.warning("token失效，请重新登录。");
      router.push({
        path: "/",
      });
    }
    return response;
  },
  function (error) {
    // 将本次请求的错误对象继续向后抛出，让接收响应的处理函数进行操作
    return Promise.reject(error);
  }
);

//php get请求
export function get(url: string, params = {}): Promise<AxiosResponse<any>> {
  return instance.get(url, {
    params: params,
  });
}
//php post请求
export function post(url: string, data = {}): Promise<AxiosResponse<any>> {
  return instance.post(url, data);
}

//java get请求
export function getJava(url: string, params = {}): Promise<AxiosResponse<any>> {
  return instanceJava.get(url, {
    params: params,
  });
}
//java post请求
export function postJava(
  url: string,
  data = {},
  config?: AxiosRequestConfig
): Promise<AxiosResponse<any>> {
  return instanceJava.post(url, data, config);
}
//java put请求
export function putJava(
  url: string,
  data = {},
  config?: AxiosRequestConfig
): Promise<AxiosResponse<any>> {
  return instanceJava.put(url, data, config);
}

//java2 get请求
export function getJava2(
  url: string,
  params = {}
): Promise<AxiosResponse<any>> {
  return instanceJava2.get(url, {
    params: params,
  });
}
//java2 post请求
export function postJava2(url: string, data = {}): Promise<AxiosResponse<any>> {
  return instanceJava2.post(url, data);
}
//java2 put请求
export function putJava2(url: string, data = {}): Promise<AxiosResponse<any>> {
  return instanceJava2.put(url, data);
}
export default {
  get,
  post,
  getJava,
  postJava,
};
